// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Funds Withdrawal – Pending / Completed / Rejected / History */
.withdrawal-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.withdrawal-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.withdrawal-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.withdrawal-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.withdrawal-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.withdrawal-section__stats,
.withdrawal-section__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.withdrawal-export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.withdrawal-export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.withdrawal-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.withdrawal-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  flex: 0 1 120px;
}

.withdrawal-page-limit__select {
  max-width: none;
  margin: 0;
  min-width: 100px;
}

.withdrawal-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #99f6e4;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.withdrawal-refresh-btn:hover:not(:disabled) {
  background: #f0fdfa;
}

.withdrawal-refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.withdrawal-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.withdrawal-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

/* Tabs */
.withdrawal-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.withdrawal-tab {
  padding: 0.85rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  margin-bottom: -1px;
}

.withdrawal-tab:hover {
  color: #0f766e;
}

.withdrawal-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.withdrawal-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #fff;
  border-bottom: 1px solid var(--border);
}

.withdrawal-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.withdrawal-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.withdrawal-search-input::placeholder {
  color: var(--text-muted);
}

.withdrawal-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.withdrawal-search-count {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.withdrawal-table-wrap {
  overflow-x: auto;
}

.withdrawal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.withdrawal-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.withdrawal-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.withdrawal-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.withdrawal-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.withdrawal-table tbody tr:hover {
  background: #f0fdfa !important;
}

.withdrawal-table tbody tr:last-child td {
  border-bottom: none;
}

.withdrawal-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.withdrawal-hash {
  font-family: ui-monospace, monospace;
  font-size: 0.78rem;
  color: #475569;
  cursor: default;
}

.withdrawal-address-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
}

.withdrawal-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  padding: 0;
  font-size: 0.75rem;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}

.withdrawal-copy-btn:hover {
  color: #0f766e;
  background: #f0fdfa;
  border-color: #99f6e4;
}

.withdrawal-tooltip-wrap {
  position: relative;
  display: inline-flex;
  max-width: 160px;
}

.withdrawal-tooltip-wrap__trigger {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.withdrawal-tooltip-box {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 30;
  min-width: 240px;
  max-width: 380px;
  padding: 0.6rem 0.75rem;
  font-family: ui-monospace, monospace;
  font-size: 0.72rem;
  line-height: 1.5;
  color: #f8fafc;
  background: #0f172a;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.28);
  white-space: pre-wrap;
  word-break: break-all;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0.15s ease;
}

.withdrawal-tooltip-box::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 1rem;
  border: 6px solid transparent;
  border-top-color: #0f172a;
}

.withdrawal-tooltip-wrap:hover .withdrawal-tooltip-box,
.withdrawal-tooltip-wrap:focus-within .withdrawal-tooltip-box {
  opacity: 1;
  visibility: visible;
}

.withdrawal-bank-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  font-family: inherit;
  font-weight: 500;
  color: #0f766e;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.withdrawal-bank-btn:hover {
  background: #ccfbf1;
}

.withdrawal-bank-btn i {
  font-size: 0.7rem;
}

.withdrawal-payment {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
}

.withdrawal-payment--crypto {
  background: #e0f2fe;
  color: #0369a1;
}

.withdrawal-payment--fiat {
  background: #fef3c7;
  color: #92400e;
}

.withdrawal-status {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
}

.withdrawal-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.withdrawal-status--completed {
  background: #dcfce7;
  color: #166534;
}

.withdrawal-status--cancelled,
.withdrawal-status--rejected {
  background: #fef2f2;
  color: #b91c1c;
}

.withdrawal-status--complete {
  background: #dcfce7;
  color: #166534;
}

.withdrawal-payment--bank {
  background: #fef3c7;
  color: #92400e;
}

.withdrawal-user-cell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.withdrawal-user-cell__id {
  font-size: 0.72rem;
}

.withdrawal-user-id {
  font-size: 0.78rem;
  word-break: break-all;
  max-width: 140px;
  display: inline-block;
}

.withdrawal-table__loading {
  text-align: center;
  padding: 2rem !important;
  color: var(--text-muted);
}

.withdrawal-table__loading i {
  margin-right: 0.5rem;
}

.withdrawal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.withdrawal-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.withdrawal-btn--approve {
  background: #dcfce7;
  color: #166534;
}

.withdrawal-btn--approve:hover {
  background: #16a34a;
  color: #fff;
}

.withdrawal-btn--cancel {
  background: #fef2f2;
  color: #b91c1c;
}

.withdrawal-btn--cancel:hover {
  background: #dc2626;
  color: #fff;
}

.withdrawal-btn--view {
  background: #e0f2fe;
  color: #0369a1;
}

.withdrawal-btn--view:hover {
  background: #0284c7;
  color: #fff;
}

.withdrawal-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

.withdrawal-empty--error {
  color: #b91c1c;
  background: #fef2f2;
  border-bottom: 1px solid #fecaca;
}

.withdrawal-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
}

.withdrawal-page-btn {
  padding: 0.45rem 0.9rem;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #99f6e4;
  border-radius: 8px;
  cursor: pointer;
}

.withdrawal-page-btn:hover:not(:disabled) {
  background: #f0fdfa;
}

.withdrawal-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.withdrawal-page-info {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.withdrawal-toast {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.25rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.withdrawal-toast--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.withdrawal-toast--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

/* Bank details modal */
.withdrawal-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.withdrawal-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.withdrawal-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.withdrawal-modal__header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
}

.withdrawal-modal__close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
}

.withdrawal-modal__close:hover {
  background: rgba(255, 255, 255, 0.35);
}

.withdrawal-modal__body {
  padding: 1.25rem 1.5rem;
}

.withdrawal-dl {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.75rem;
}

.withdrawal-dl div {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 0.5rem;
  align-items: start;
}

.withdrawal-dl dt {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted);
}

.withdrawal-dl dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
}

.withdrawal-dl dd.withdrawal-mono {
  font-size: 0.85rem;
}

.withdrawal-mono--wrap {
  word-break: break-all;
}

.withdrawal-modal--action {
  max-width: 520px;
}

.withdrawal-approval-mode {
  margin-bottom: 0.5rem;
}

.withdrawal-approval-mode__label {
  margin: 0 0 0.65rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text);
}

.withdrawal-approval-mode__options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.withdrawal-approval-mode__option {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
}

.withdrawal-approval-mode__option:has(input:checked) {
  border-color: #0f766e;
  background: #f0fdfa;
}

.withdrawal-approval-mode__option input {
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.withdrawal-approval-mode__option span {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.withdrawal-approval-mode__option strong {
  font-size: 0.9rem;
  color: var(--text);
}

.withdrawal-approval-mode__option small {
  font-size: 0.78rem;
  color: var(--text-muted);
  line-height: 1.35;
}

.withdrawal-dl--compact {
  margin-bottom: 1rem;
}

.withdrawal-form-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 0.75rem;
}

.withdrawal-required {
  color: #b91c1c;
}

.withdrawal-form-input {
  display: block;
  width: 100%;
  margin-top: 0.35rem;
  padding: 0.6rem 0.75rem;
  font-size: 0.9rem;
  font-family: ui-monospace, monospace;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-sizing: border-box;
}

.withdrawal-form-input:focus {
  outline: none;
  border-color: #0f766e;
}

.withdrawal-fee-note {
  font-size: 0.8rem;
  color: var(--text-muted);
  font-weight: 400;
}

.withdrawal-action-error {
  margin: 0.5rem 0 0;
  font-size: 0.85rem;
  color: #b91c1c;
}

.withdrawal-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.withdrawal-btn--ghost {
  background: #f1f5f9;
  color: #475569;
}

.withdrawal-btn--ghost:hover {
  background: #e2e8f0;
}

.withdrawal-metamask {
  margin-bottom: 1.25rem;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #c4b5fd;
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
}

.withdrawal-metamask__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #5b21b6;
  margin-bottom: 0.75rem;
}

.withdrawal-metamask__head i {
  font-size: 1.1rem;
}

.withdrawal-metamask__body {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.withdrawal-metamask__hint {
  margin: 0;
  font-size: 0.82rem;
  color: #6b7280;
  line-height: 1.45;
}

.withdrawal-metamask__connected {
  margin: 0;
  font-size: 0.85rem;
  color: #374151;
}

.withdrawal-metamask__connect,
.withdrawal-metamask__send,
.withdrawal-metamask__install {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  align-self: flex-start;
  padding: 0.55rem 0.9rem;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: inherit;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s, opacity 0.2s;
}

.withdrawal-metamask__connect,
.withdrawal-metamask__send {
  color: #fff;
  background: #7c3aed;
  border: none;
}

.withdrawal-metamask__connect:hover:not(:disabled),
.withdrawal-metamask__send:hover:not(:disabled) {
  background: #6d28d9;
}

.withdrawal-metamask__connect:disabled,
.withdrawal-metamask__send:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.withdrawal-metamask__install {
  color: #5b21b6;
  background: #fff;
  border: 1px solid #c4b5fd;
}

.withdrawal-metamask__install:hover {
  background: #faf5ff;
}

.withdrawal-metamask__error {
  margin: 0.65rem 0 0;
  font-size: 0.82rem;
  color: #b91c1c;
}

.withdrawal-metamask__notice {
  margin: 0 0 1rem;
  padding: 0.75rem 0.9rem;
  font-size: 0.82rem;
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
}

/* TronLink (TRC20) variant — red accent */
.withdrawal-metamask--tron {
  border-color: #fca5a5;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
}

.withdrawal-metamask--tron .withdrawal-metamask__head {
  color: #b91c1c;
}

.withdrawal-metamask--tron .withdrawal-metamask__send,
.withdrawal-metamask--tron .withdrawal-metamask__connect {
  background: #dc2626;
}

.withdrawal-metamask--tron .withdrawal-metamask__send:hover:not(:disabled),
.withdrawal-metamask--tron .withdrawal-metamask__connect:hover:not(:disabled) {
  background: #b91c1c;
}

.withdrawal-metamask--tron .withdrawal-metamask__install {
  color: #b91c1c;
  background: #fff;
  border-color: #fca5a5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Funds/FundsWithdrawalPage.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Funds Withdrawal – Pending / Completed / Rejected / History */\n.withdrawal-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.withdrawal-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.withdrawal-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.withdrawal-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.withdrawal-section__stats,\n.withdrawal-section__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.withdrawal-export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.withdrawal-export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.withdrawal-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.withdrawal-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex: 0 1 120px;\n}\n\n.withdrawal-page-limit__select {\n  max-width: none;\n  margin: 0;\n  min-width: 100px;\n}\n\n.withdrawal-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #99f6e4;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.withdrawal-refresh-btn:hover:not(:disabled) {\n  background: #f0fdfa;\n}\n\n.withdrawal-refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.withdrawal-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.withdrawal-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n/* Tabs */\n.withdrawal-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-tab {\n  padding: 0.85rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n  margin-bottom: -1px;\n}\n\n.withdrawal-tab:hover {\n  color: #0f766e;\n}\n\n.withdrawal-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.withdrawal-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.withdrawal-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.withdrawal-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.withdrawal-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.withdrawal-search-count {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.withdrawal-table-wrap {\n  overflow-x: auto;\n}\n\n.withdrawal-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.withdrawal-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.withdrawal-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.withdrawal-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.withdrawal-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.withdrawal-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.withdrawal-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.withdrawal-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.withdrawal-hash {\n  font-family: ui-monospace, monospace;\n  font-size: 0.78rem;\n  color: #475569;\n  cursor: default;\n}\n\n.withdrawal-address-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  max-width: 100%;\n}\n\n.withdrawal-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  font-size: 0.75rem;\n  color: #64748b;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: color 0.2s, background 0.2s, border-color 0.2s;\n}\n\n.withdrawal-copy-btn:hover {\n  color: #0f766e;\n  background: #f0fdfa;\n  border-color: #99f6e4;\n}\n\n.withdrawal-tooltip-wrap {\n  position: relative;\n  display: inline-flex;\n  max-width: 160px;\n}\n\n.withdrawal-tooltip-wrap__trigger {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.withdrawal-tooltip-box {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  z-index: 30;\n  min-width: 240px;\n  max-width: 380px;\n  padding: 0.6rem 0.75rem;\n  font-family: ui-monospace, monospace;\n  font-size: 0.72rem;\n  line-height: 1.5;\n  color: #f8fafc;\n  background: #0f172a;\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.28);\n  white-space: pre-wrap;\n  word-break: break-all;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n}\n\n.withdrawal-tooltip-box::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 1rem;\n  border: 6px solid transparent;\n  border-top-color: #0f172a;\n}\n\n.withdrawal-tooltip-wrap:hover .withdrawal-tooltip-box,\n.withdrawal-tooltip-wrap:focus-within .withdrawal-tooltip-box {\n  opacity: 1;\n  visibility: visible;\n}\n\n.withdrawal-bank-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.5rem;\n  font-size: 0.8rem;\n  font-family: inherit;\n  font-weight: 500;\n  color: #0f766e;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.withdrawal-bank-btn:hover {\n  background: #ccfbf1;\n}\n\n.withdrawal-bank-btn i {\n  font-size: 0.7rem;\n}\n\n.withdrawal-payment {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.withdrawal-payment--crypto {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.withdrawal-payment--fiat {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.withdrawal-status {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.withdrawal-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.withdrawal-status--completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.withdrawal-status--cancelled,\n.withdrawal-status--rejected {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.withdrawal-status--complete {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.withdrawal-payment--bank {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.withdrawal-user-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.withdrawal-user-cell__id {\n  font-size: 0.72rem;\n}\n\n.withdrawal-user-id {\n  font-size: 0.78rem;\n  word-break: break-all;\n  max-width: 140px;\n  display: inline-block;\n}\n\n.withdrawal-table__loading {\n  text-align: center;\n  padding: 2rem !important;\n  color: var(--text-muted);\n}\n\n.withdrawal-table__loading i {\n  margin-right: 0.5rem;\n}\n\n.withdrawal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.withdrawal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.withdrawal-btn--approve {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.withdrawal-btn--approve:hover {\n  background: #16a34a;\n  color: #fff;\n}\n\n.withdrawal-btn--cancel {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.withdrawal-btn--cancel:hover {\n  background: #dc2626;\n  color: #fff;\n}\n\n.withdrawal-btn--view {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.withdrawal-btn--view:hover {\n  background: #0284c7;\n  color: #fff;\n}\n\n.withdrawal-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.withdrawal-empty--error {\n  color: #b91c1c;\n  background: #fef2f2;\n  border-bottom: 1px solid #fecaca;\n}\n\n.withdrawal-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n}\n\n.withdrawal-page-btn {\n  padding: 0.45rem 0.9rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #99f6e4;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.withdrawal-page-btn:hover:not(:disabled) {\n  background: #f0fdfa;\n}\n\n.withdrawal-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.withdrawal-page-info {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.withdrawal-toast {\n  position: fixed;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.25rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.withdrawal-toast--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.withdrawal-toast--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n/* Bank details modal */\n.withdrawal-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.withdrawal-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n}\n\n.withdrawal-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.withdrawal-modal__header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.withdrawal-modal__close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.withdrawal-modal__close:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.withdrawal-modal__body {\n  padding: 1.25rem 1.5rem;\n}\n\n.withdrawal-dl {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.withdrawal-dl div {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 0.5rem;\n  align-items: start;\n}\n\n.withdrawal-dl dt {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.withdrawal-dl dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.withdrawal-dl dd.withdrawal-mono {\n  font-size: 0.85rem;\n}\n\n.withdrawal-mono--wrap {\n  word-break: break-all;\n}\n\n.withdrawal-modal--action {\n  max-width: 520px;\n}\n\n.withdrawal-approval-mode {\n  margin-bottom: 0.5rem;\n}\n\n.withdrawal-approval-mode__label {\n  margin: 0 0 0.65rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.withdrawal-approval-mode__options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.85rem;\n}\n\n.withdrawal-approval-mode__option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: #f8fafc;\n  cursor: pointer;\n}\n\n.withdrawal-approval-mode__option:has(input:checked) {\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.withdrawal-approval-mode__option input {\n  margin-top: 0.2rem;\n  flex-shrink: 0;\n}\n\n.withdrawal-approval-mode__option span {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.withdrawal-approval-mode__option strong {\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.withdrawal-approval-mode__option small {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  line-height: 1.35;\n}\n\n.withdrawal-dl--compact {\n  margin-bottom: 1rem;\n}\n\n.withdrawal-form-label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 0.75rem;\n}\n\n.withdrawal-required {\n  color: #b91c1c;\n}\n\n.withdrawal-form-input {\n  display: block;\n  width: 100%;\n  margin-top: 0.35rem;\n  padding: 0.6rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: ui-monospace, monospace;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.withdrawal-form-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.withdrawal-fee-note {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.withdrawal-action-error {\n  margin: 0.5rem 0 0;\n  font-size: 0.85rem;\n  color: #b91c1c;\n}\n\n.withdrawal-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.withdrawal-btn--ghost {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.withdrawal-btn--ghost:hover {\n  background: #e2e8f0;\n}\n\n.withdrawal-metamask {\n  margin-bottom: 1.25rem;\n  padding: 1rem;\n  border-radius: 10px;\n  border: 1px solid #c4b5fd;\n  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);\n}\n\n.withdrawal-metamask__head {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #5b21b6;\n  margin-bottom: 0.75rem;\n}\n\n.withdrawal-metamask__head i {\n  font-size: 1.1rem;\n}\n\n.withdrawal-metamask__body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.withdrawal-metamask__hint {\n  margin: 0;\n  font-size: 0.82rem;\n  color: #6b7280;\n  line-height: 1.45;\n}\n\n.withdrawal-metamask__connected {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #374151;\n}\n\n.withdrawal-metamask__connect,\n.withdrawal-metamask__send,\n.withdrawal-metamask__install {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  align-self: flex-start;\n  padding: 0.55rem 0.9rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 8px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.2s, opacity 0.2s;\n}\n\n.withdrawal-metamask__connect,\n.withdrawal-metamask__send {\n  color: #fff;\n  background: #7c3aed;\n  border: none;\n}\n\n.withdrawal-metamask__connect:hover:not(:disabled),\n.withdrawal-metamask__send:hover:not(:disabled) {\n  background: #6d28d9;\n}\n\n.withdrawal-metamask__connect:disabled,\n.withdrawal-metamask__send:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.withdrawal-metamask__install {\n  color: #5b21b6;\n  background: #fff;\n  border: 1px solid #c4b5fd;\n}\n\n.withdrawal-metamask__install:hover {\n  background: #faf5ff;\n}\n\n.withdrawal-metamask__error {\n  margin: 0.65rem 0 0;\n  font-size: 0.82rem;\n  color: #b91c1c;\n}\n\n.withdrawal-metamask__notice {\n  margin: 0 0 1rem;\n  padding: 0.75rem 0.9rem;\n  font-size: 0.82rem;\n  color: #92400e;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n}\n\n/* TronLink (TRC20) variant — red accent */\n.withdrawal-metamask--tron {\n  border-color: #fca5a5;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n}\n\n.withdrawal-metamask--tron .withdrawal-metamask__head {\n  color: #b91c1c;\n}\n\n.withdrawal-metamask--tron .withdrawal-metamask__send,\n.withdrawal-metamask--tron .withdrawal-metamask__connect {\n  background: #dc2626;\n}\n\n.withdrawal-metamask--tron .withdrawal-metamask__send:hover:not(:disabled),\n.withdrawal-metamask--tron .withdrawal-metamask__connect:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.withdrawal-metamask--tron .withdrawal-metamask__install {\n  color: #b91c1c;\n  background: #fff;\n  border-color: #fca5a5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
